import React, { useEffect, useState } from "react"
import styled from "@emotion/styled"
import { initMercadoPago, Wallet } from "@mercadopago/sdk-react"
import { navigate } from "@reach/router"

import PageLayout from "../page-layout"
import { useAuth } from "../../hooks/auth-context"
import MP from "../../services/mercadopago"

import LoadingScreenIcon from "../ui/images/loading-screen"
import mercadoPagoLogo from "../../images/mercadopago-logo.svg"
import ButtonCustomV2 from "../ui/custom-button-v2"
import { css } from "@emotion/react"
import { useFeatureIsOn } from "@growthbook/growthbook-react"


const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 5rem;
`

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const Container = styled.div`
  min-width: 600px;
  background-color: white;
  border: 1px solid #c4cdd5;
  border-radius: 5px;
  padding: 25px;
  display: flex;
  flex-direction: column;
  align-items: center;

  > div {
    max-width: 414px;
  }
`

const ContainerInput = styled.div`
  position: relative;
  display: table;
  border-collapse: separate;
  width: 100%;
`

const WrapperInput = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`

const PrefixSpan = styled.span`
  padding: 6px 12px;
  font-size: 14px;
  font-weight: 400;
  line-height: 1;
  color: black;
  text-align: center;
  border: 1px solid #919eab;
  width: 1%;
  white-space: nowrap;
  vertical-align: middle;
  display: table-cell;
  border-right: 0;
  border-radius: 8px 0px 0px 8px;
`

const InputDeposit = styled.input`
  border: 1px solid #919eab;
  border-radius: 8px;
  width: 358px;
  height: 56px;
  border-radius: 0px 8px 8px 0px;
  border-left: none;
`

const ContainerButton = styled(WrapperInput)`
  margin-top: 15px;
`

const styleButton = css`
  background-color: #2BA770;
  color: white;
  border: none;
  border-radius: 8px;
  width: 100%;
  height: 50px;
`

const disabledStyleButton = css`
  color: white;
  border: none;
  border-radius: 8px;
  width: 100%;
  height: 50px;
`

const DepositAfter = styled.a`
  cursor: pointer;
  margin-top: 10px;
  text-decoration: underline;
`

const LabelPayment = styled.div`
  background-color: #DDF2FA;
  width: 600px;
  color: black;
  padding-top: 17px;
  padding-bottom: 17px;
  font-size: 20px;
  line-height: 26px;
  display: flex;
  justify-content: center;
`

const ContainerUpdatedCreditCard = styled.div`
  min-width: 600px;
  background-color: white;
  border-radius: 5px;
  padding: 25px;
`

type Props = {
  kyc?: boolean
}

const MercadoPagoUruguayView = ({ kyc = false }: Props) => {
  const { state } = useAuth()
  const { user } = state
  const [preferenceId, setPreferenceId] = useState<null | string>(null)
  const [loadingMP, setLoadingMP] = useState(false)
  const [amount, setAmount] = useState<number>(0)

  useEffect(() => {
    initMercadoPago('APP_USR-968165ca-aecb-4c5f-bc5b-c68b5c2122a7')
  }, [])

  const isMercadoPagoEnabled = useFeatureIsOn("payment-mercadopago-uruguay")

  if (!user) {
    return (
      <LoadingWrapper>
        <LoadingScreenIcon />
      </LoadingWrapper>
    )
  }

  const createPreference = async (user: User, amount: number) => {
    if (!isMercadoPagoEnabled) return

    setLoadingMP(true)

    if (loadingMP) return

    const preference = await MP.createPreference(user, amount, 'UY', 'UYU')
    if (!preference) {
      setLoadingMP(false)
      return
    }
    setPreferenceId(preference)
  }

  const onBack = () => {
    setPreferenceId(null)
    navigate(`/${user.kycNextStep}`)
  }

  return (
    <PageLayout>
      <Layout>
        <img src={mercadoPagoLogo} alt="Mercado Pago" style={{ width: "450px" }} />
        {!preferenceId && (
          <Container>
            {isMercadoPagoEnabled && (
              <>
                <WrapperInput>
                  <ContainerInput>
                    <PrefixSpan>UYU</PrefixSpan>
                    <InputDeposit
                      id="sessionField"
                      placeholder="Monto a depositar"
                      type="text"
                      value={amount || ""}
                      onChange={(e) => setAmount(parseInt(e.target.value, 10))}
                    />
                  </ContainerInput>
                </WrapperInput>
                <ContainerButton>
                  <ButtonCustomV2
                    loading={loadingMP}
                    disabled={amount === 0}
                    style={styleButton}
                    disabledStyle={disabledStyleButton}
                    loadingStyle={styleButton}
                    onClick={() => createPreference(user, amount)}
                  >
                    Depositar
                  </ButtonCustomV2>
                </ContainerButton>
              </>
            )}
            {!isMercadoPagoEnabled && (
              <ContainerUpdatedCreditCard>
                Estamos actualizando para que tengas una mejor experiencia con Capitaria
              </ContainerUpdatedCreditCard>
            )}
          </Container>
        )}
        {preferenceId && isMercadoPagoEnabled && (
          <>
            {loadingMP && <LoadingScreenIcon />}
            {!loadingMP && (
              <LabelPayment>
                Monto a depositar: ${amount}
              </LabelPayment>
            )}
            <Wallet
              initialization={{ preferenceId }}
              customization={{ texts: { valueProp: 'smart_option' } }}
              onReady={() => { setLoadingMP(false) }}
            />
          </>
        )}

        {kyc && <DepositAfter onClick={onBack}> {"<-"} Volver atras</DepositAfter>}
      </Layout>
    </PageLayout>
  )
}

export default MercadoPagoUruguayView
